import { state } from "../state.js";

export function setStatus(wsStatus) {
  document.getElementById("status").innerHTML = state.debug ? wsStatus : "";
}

export function debuggPrint(message) {
  if (state.debug) {
    console.log(message);
  }
}

export function setLogo(logoName) {
  document.getElementById("logo").src = state.configJSON.ImageUrl + logoName;
}

export function setInfoText(data) {
  if (data === undefined) data = "";
  document.getElementById("infoText").innerHTML = data !== "" ? "Info: " + data : "";
}

// Sets or removes a query parameter on the current URL in place (via the
// standard URL/URLSearchParams API) without reloading the page. Pass `null`
// to remove the parameter; any string (including "") sets it to that value.
export function setParameterInCurrentURL(parameterName, value) {
  const url = new URL(window.location.href);
  if (value === null) {
    url.searchParams.delete(parameterName);
  } else {
    url.searchParams.set(parameterName, value);
  }
  window.history.replaceState({}, "", url);
}

export function switchThemeMode(changeUrl = true) {
  const check = document.getElementById("darkmode");
  const theme = document.getElementById("theme");
  theme.href = check.checked ? "css/stylesheet_dark.css" : "css/stylesheet_light.css";
  if (changeUrl) {
    setParameterInCurrentURL("dark", check.checked ? "" : null);
  }
}

// Builds one ranking tab (button + content <div> + <table>) and registers it
// in state.tableIdentifires, which drives createRankingHead/updateRanking.
// isOverview marks "ALL"-style tabs (spanning every class, e.g. race/
// training's ALL tab, slalom's "All"/"AllV1"/"AllV2"/"AllALL") as opposed to
// a specific class/group tab - see urlValueForTab().
export function createTab(rankingdiv, tab, identifire, classes, title, ranking, rtype, setFocus = false, isOverview = false) {
  const btn = document.createElement("button");
  btn.id = "btn" + identifire;
  btn.className = "tablinks";
  btn.textContent = title;
  btn.addEventListener("click", () => switchTab(identifire));
  tab.append(btn);

  const site = document.createElement("div");
  site.className = "tabcontent";
  site.id = "site" + identifire;
  const tbl = document.createElement("table");
  tbl.id = "tblRanking" + identifire;
  site.append(tbl);
  rankingdiv.append(site);

  state.tableIdentifires.push({
    Classes: classes,
    tableId: tbl.id,
    Ranking: ranking,
    Identifire: identifire,
    RankingType: rtype,
    IsOverview: isOverview,
  });

  if (setFocus) {
    state.currentButton = btn;
    state.currentSite = site;
    state.currentButton.classList.add("active");
    state.currentSite.style.display = "block";
  }
}

// The "?class=" value for a given tab identifire: null (omit the param) for
// an overview tab or one that no longer exists, otherwise the identifire
// itself - so a reload restores the exact sub-tab (e.g. "G0V1" vs "G0V2").
export function urlValueForTab(identifire) {
  const entry = state.tableIdentifires.find((t) => t.Identifire === identifire);
  return entry?.IsOverview ? null : identifire;
}

export function switchTab(newTab) {
  state.currentButton.classList.remove("active");
  state.currentSite.style.display = "none";
  state.currentButton = document.getElementById("btn" + newTab);
  state.currentButton.classList.add("active");
  state.currentSite = document.getElementById("site" + newTab);
  state.currentSite.style.display = "block";

  setParameterInCurrentURL("class", urlValueForTab(newTab));

  // Keep the default-class memory (used by createTab's setFocus decisions on
  // future rebuilds, e.g. after a server-driven class-list change) in sync too.
  const entry = state.tableIdentifires.find((t) => t.Identifire === newTab);
  state.newClass = entry && entry.Classes.length === 1 ? entry.Classes[0] : "ALL";
}
